import React, { useState, useEffect } from "react";
import TopBar from "@/components/TopBar";
import Leaderboard from "@/components/Leaderboard";
import { api } from "@/lib/api";

export default function LeaderboardPage() {
  const [settings, setSettings] = useState({});
  useEffect(() => { api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  return (
    <div style={{ minHeight: "100vh" }}>
      <TopBar brandBg={settings.brand_bg_url} />
      <div style={{ maxWidth: 1000, margin: "0 auto", padding: "32px 20px 80px" }}>
        <Leaderboard full />
      </div>
    </div>
  );
}
